import React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import Collection from './components/Products';
import ProductBuyers from './components/Product_Buyers';
import ProductBuyer from './components/Product_Buyer';
import CollectionInventory from './components/Inventories';
import CollectionIoi_Inspection from './components/Ioi_Inspections';
import CollectionManufactured from './components/Manufactureds';
import CollectionUPC from './components/UPCS';
import CollectionProductsEForm from './components/E_Form_Products';

import Object from './components/Product'; //Take off S
import ObjectInventory from './components/Inventory';
import ObjectIoi_Inspection from './components/Ioi_Inspection';
import ObjectManufactured from './components/Manufactured';
import ObjectUPC from './components/UPC.js';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, locations, states, scannedCode,userAccess}) => (

	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}/e_form_products`}>
				<CollectionProductsEForm locations={locations} states={states}/>
			</ErrorBoundaryRoute>
			
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection locations={locations} states={states} scannedCode={scannedCode}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/product_buyers`}>
				<ProductBuyers locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/product_buyers/:id`}>
				<ProductBuyer locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/inventories`}>
				<CollectionInventory locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/inventories/:id`}>
				<ObjectInventory locations={locations} states={states} scannedCode={scannedCode} baseUrl={`${match.url}/inventories`}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/ioi_inspections`}>
				<CollectionIoi_Inspection locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/ioi_inspections/:id`}>
				<ObjectIoi_Inspection locations={locations} states={states} baseUrl={`${match.url}`}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/manufactureds`}>
				<CollectionManufactured locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/manufactureds/:id`}>
				<ObjectManufactured locations={locations} states={states}  userAccess={userAccess} baseUrl={`${match.url}`}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/upc_center`}>
				<CollectionUPC locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/upc_center/:id`}>
				<ObjectUPC locations={locations} states={states}  baseUrl={`${match.url}`}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object locations={locations} states={states} userAccess={userAccess} baseUrl={`${match.url}`}/>
			</ErrorBoundaryRoute>



			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);